const defaultTheme = {
  "primary": "#1568A6",
  "foreground": "#000000",
  "primary-foreground": "#fff",
  "secondary": "#1568A6",
  "background": "#fff",
  "haze-background": "#f5f5f5", // Light gray for haze effects
  "sjs-font-family": 'Outfit, San Francisco, helvetica neue, helvetica, arial, sans-serif'
}

export function initializeCompanyTheme(company_customizations) {
    const customizationStylesheet = JSON.parse(company_customizations || "{}");
    const color = getPrimaryColor(customizationStylesheet, defaultTheme);
    const colorLight = lightenHexColor(color, 0.2); // Lighten by 20%

    const companyTheme = {
      "sjs-primary-background-500": color,
      "sjs-primary-background-400": color,
      "sjs-primary-background-300": color,
      "sjs-primary-background-600": color,
      "sjs-secondary-background-500": color,
      "sjs-secondary-background-400": color,
      "sjs-semantic-green-background-500": color,
      // "sjs-secondary-background-25": color,
      "sjs-special-background": colorLight,
      "sjs-primary-backcolor": color,
      "sjs-primary-backcolor-light": colorLight,
      "sjs-primary-backcolor-dark": color,
      "sjs-font-family": defaultTheme["sjs-font-family"],
      "sjs-special-haze": defaultTheme["haze-background"],
      "ctr-popup-haze-background-color": defaultTheme["haze-background"],
    };
  return companyTheme;
}

export function setCompanyStyles(root, theme) {
  root.style.setProperty("--sjs-primary-background-500", theme["sjs-primary-background-500"]);
  root.style.setProperty("--sjs-primary-background-400", theme["sjs-primary-background-400"]);
  root.style.setProperty("--sjs-primary-background-300", theme["sjs-primary-background-300"]);
  root.style.setProperty("--sjs-primary-background-600", theme["sjs-primary-background-600"]);
  root.style.setProperty("--sjs-secondary-background-500", theme["sjs-secondary-background-500"]);
  root.style.setProperty("--sjs-secondary-background-400", theme["sjs-secondary-background-400"]);
  root.style.setProperty("--sjs-semantic-green-background-500", theme["sjs-semantic-green-background-500"]);
  root.style.setProperty("--sjs-secondary-background-25", theme["sjs-secondary-background-25"]);
  root.style.setProperty("--sjs-special-background", theme["ctr-popup-haze-background-color"]);
  root.style.setProperty("--sjs-primary-backcolor", theme["sjs-primary-background-300"]);
  root.style.setProperty("--sjs-primary-backcolor-light", theme["sjs-primary-background-300-light"]);
  root.style.setProperty("--sjs-primary-backcolor-dark", theme["sjs-primary-background-300"]);
  root.style.setProperty("--sjs-font-family", theme["sjs-font-family"]);
  root.style.setProperty("--sjs-special-haze", theme["sjs-special-haze"]);
}

function lightenHexColor(hexColor, amount) {
  // Convert hex to RGB
  let r = parseInt(hexColor.substring(1, 3), 16);
  let g = parseInt(hexColor.substring(3, 5), 16);
  let b = parseInt(hexColor.substring(5, 7), 16);

  // Lighten the RGB values
  r = Math.round(r * (1 - amount) + 255 * amount);
  g = Math.round(g * (1 - amount) + 255 * amount);
  b = Math.round(b * (1 - amount) + 255 * amount);

  // Convert RGB back to hex
  r = r.toString(16).padStart(2, '0');
  g = g.toString(16).padStart(2, '0');
  b = b.toString(16).padStart(2, '0');

  return `#${r}${g}${b}`;
}

function namedColorToHex(color) {
  const ctx = document.createElement("canvas").getContext("2d");
  ctx.fillStyle = color;
  return ctx.fillStyle;
}

function isHexColor(color) {
  const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return hexRegex.test(color);
}

function getPrimaryColor(customizationStylesheet, defaultTheme) {
  let primaryColor = customizationStylesheet?.['stylesheet']?.match(/\$headerBg:\s*([^;\s]+)/)?.[1] ?? defaultTheme['primary'];
  return isHexColor(primaryColor) ? primaryColor : namedColorToHex(primaryColor);
}